/**
 * Extracts the phone number from a SIP URI.
 * Example: `sip:+905321234567@domain.com` → `+905321234567`
 *
 * Returns the original input if parsing fails.
 */
export function parseSipPhoneNumber(sipUri: string): string {
  if (!sipUri) {
    return '';
  }

  const match = sipUri.match(/^sip:([^@]+)@/i);
  return match ? match[1] : sipUri;
}
